import dayjs from 'dayjs';
import { Typography } from 'antd';

import { formatDate } from 'utilities/datesAndTimes';

const { Text } = Typography;

const IntroAndFutureApr = ({ pricingDetails }) => {
  const { futureApr, futureAprStartDate, introAprLengthInMonths } =
    pricingDetails;

  const introAprExpirationDate = futureAprStartDate
    ? dayjs(futureAprStartDate).subtract(1, 'day').format()
    : null;

  const introAprExpirationText = introAprExpirationDate
    ? `Through ${formatDate(introAprExpirationDate)}`
    : null;
  const introAprExpirationLengthInMonths = introAprLengthInMonths
    ? `For ${introAprLengthInMonths} Months`
    : 'Through --/--/----';

  const introAprStartDateText = futureAprStartDate
    ? `Starting ${formatDate(futureAprStartDate)}`
    : null;
  const introAprStartLengthInMonths = introAprLengthInMonths
    ? `Starting in ${introAprLengthInMonths} Months`
    : 'Starting --/--/----';

  const futurePurchaseAprText = futureApr ? (
    `${futureApr}%`
  ) : (
    <Text type="secondary" italic>
      Pending
    </Text>
  );

  return (
    <div data-testid="apr">
      <span data-testid="intro-apr">
        Introductory Rate - {pricingDetails.purchaseApr}%{' '}
        {pricingDetails.purchaseAprType?.toLowerCase()}
      </span>
      <br />
      <Text type="secondary" data-testid="intro-apr-expiration">
        {introAprExpirationText || introAprExpirationLengthInMonths}
      </Text>
      <br />
      <br />
      <span data-testid="future-apr">
        Purchase APR - {futurePurchaseAprText}
      </span>
      <br />
      <Text type="secondary" data-testid="future-apr-start">
        {introAprStartDateText || introAprStartLengthInMonths}
      </Text>
    </div>
  );
};

const APR = ({ pricingDetails }) => {
  if (pricingDetails?.futureApr || pricingDetails?.futureAprStartDate) {
    return <IntroAndFutureApr pricingDetails={pricingDetails} />;
  } else {
    return (
      <span data-testid="apr">
        {pricingDetails?.purchaseApr}%{' '}
        {pricingDetails?.purchaseAprType?.toLowerCase()}
      </span>
    );
  }
};

export default APR;
